import { getCustomSize, styled } from '@taraai/design-system';
import Icon from 'components/core/controllers/views/Icon';

export const ActionIcon = styled(Icon, { height: getCustomSize(10), width: getCustomSize(10), color: '$focus' });
